module.exports = __webpack_public_path__ + "img/access-facebook-effect.8864f7de.png";